// extracted by mini-css-extract-plugin
module.exports = {"not-yet":"not-yet_not-yet__eUYFm"};